import { CURRENCY } from "../uploadedBoard";
import { Parameter } from "./parameters";
import { MSLLevel } from "../../components/component-search/PartDrawer/Inventory/PhysicalInventory/AddNewContainer";

export interface PartProperty {
  parameter: Parameter;
  raw: string;
  quantity: number | null;
  value: string | null;
}

export interface PriceInfo {
  unit_price: number;
  quantity: number;
  currency: CURRENCY;
}

export enum InfoSource {
  OCTOPART = "Octopart",
  MANUAL_ENTRY = "Manual entry",
}

export interface ReelDetails {
  reel_width_mm: number;
  reel_pitch_mm: number;
}

export enum PlacementType {
  MACHINE_PLACED = "Machine placed",
  HAND_SOLDERED = "Hand soldered",
  HAND_PLACED = "Hand placed",
  PRESS_FIT = "Press fit",
  SELECTIVE_SOLDERED = "Selective soldered",
  MECHANICAL_ASSEMBLY = "Mechanical assembly",
}

export interface Part {
  id: string | null;
  octopart_id: string | null;
  name: string;
  pick_and_place_name: string;
  alternate_names: string[];
  alternate_pick_and_place_names: string[];
  short_description: string;
  properties: PartProperty[];
  requires_stencil: boolean;
  num_through_hole_joints: number;
  manufacturer: string | null;
  inventory_level: number;
  physical_inventory_level: number;
  total_active_allocations: number;
  total_spent_allocations: number;
  total_last_counted_amount: number;
  price_info: PriceInfo | null;
  image_url: string | null;
  datasheet_url: string | null;
  user_id: null | string;
  source: InfoSource;
  reel_details: ReelDetails;
  placement_type: string | null;
  paste_in_hole: boolean;
  cannot_clean: boolean;
  moisture_sensitivity_level: MSLLevel | null;
  // The part machine is working on the part, so its inventory and
  // allocations may be about to change
  is_updating: boolean;
}
